function checkLogin() {
  // 로그인 체크
  var loginUser = localStorage.loginUser;

  if (loginUser === "springsoft") {
    return true;
  }
  return false;
}

export {checkLogin};
